import React from 'react'
import Headline from 'gatsby-theme-kn/src/components/atoms/Headline'
import Richtext from 'gatsby-theme-kn/src/components/atoms/Richtext'
import Figure from 'gatsby-theme-kn/src/components/atoms/Figure'
import Polaroid from 'gatsby-theme-kn/src/components/atoms/Polaroid'
import Postit from 'gatsby-theme-kn/src/components/atoms/Postit'
import SbEditable from 'storyblok-react'
import Link from 'gatsby-theme-kn/src/components/atoms/Link'

const TextWithImageBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`content-block-two-col text-with-image-block text-with-image-block-text-valign-${
          block.text_vertical_align
        } text-with-image-block-image-size-${block.image_size} ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''} ${
          block.ratio ? block.ratio : ''
        } ${block.paper_style === true ? 'paper-style' : ''}`}
      >
        <div className="content-block-two-col-body">
          <div className="row">
            {block.image_align === 'right' ? (
              <>
                <div className="content-col-2 content-col-text">
                  <Headline
                    kicker={block.kicker}
                    headline={block.headline}
                    subheadline={block.subheadline}
                    headline_level={block.headline_level}
                  />
                  <Richtext text={block.text} />
                  {block.link?.cached_url?.length > 0 && (
                    <Link className="btn btn-primary" link={block.link}>
                      {block.link_text}
                    </Link>
                  )}
                </div>
                <div className="content-col-2 content-col-image">
                  {block.style === 'polaroid' ? (
                    <Polaroid image={block.image} caption={block.caption} />
                  ) : block.style === 'postit' &&
                    block.postit_text.length > 0 ? (
                    <Postit text={block.postit_text} />
                  ) : (
                    <Figure
                      image={block.image}
                      image_link={block.image_link}
                      align_image={block.align_image}
                      image_size={block.image_size}
                      caption={block.caption}
                      parallax={false}
                    />
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="content-col-2 content-col-image">
                  {block.style === 'polaroid' ? (
                    <Polaroid image={block.image} caption={block.caption} />
                  ) : block.style === 'postit' &&
                    block.postit_text.length > 0 ? (
                    <Postit text={block.postit_text} />
                  ) : (
                    <Figure
                      image={block.image}
                      image_link={block.image_link}
                      align_image={block.align_image}
                      image_size={block.image_size}
                      caption={block.caption}
                      parallax={false}
                    />
                  )}
                </div>
                <div className="content-col-2 content-col-text">
                  <Headline
                    kicker={block.kicker}
                    headline={block.headline}
                    subheadline={block.subheadline}
                    headline_level={block.headline_level}
                  />
                  <Richtext text={block.text} />
                  {block.link?.cached_url?.length > 0 && (
                    <Link className="btn btn-primary" link={block.link}>
                      {block.link_text}
                    </Link>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default TextWithImageBlock
